import React from "react";

export default function Video() {
  return (
    <div>
      <h3>.</h3>
    </div>
  );
}